var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},_vm._l((4),function(item){return _c('img',{key:item,attrs:{"src":_vm.getUrl(item)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }